import { Button, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { format } from "date-fns";
import { FC } from "react";

export const PrintAction: FC<{ action: any, handlePrint?: (id: number) => void }> = ({ action, handlePrint }) => {
 return (
  <TableBody>
   <TableRow key={action.id}>
    <TableCell>{action.quantity}</TableCell>
    <TableCell>{action.facture}</TableCell>
    <TableCell>
     {(action.product_lists || []).map((product: any, index: any) => (
      <Chip label={product.name || "-"} key={index} size="small" sx={{ mr: 1 }} />
     ))}
    </TableCell>
    <TableCell>{format(new Date(action.createdAt), 'MMMM d, yyyy')}</TableCell>
    <TableCell>
     <Button variant="outlined" onClick={() => handlePrint && handlePrint(action.id)}>
      Print
     </Button>
    </TableCell>
   </TableRow>
  </TableBody>
 )
}